    import { Injectable } from '@angular/core';
import { Api } from '../../core/api';
import { Observable } from 'rxjs/Observable';
import { DailySales } from '../../model/stat/daily-sales';
import { RESOURCES } from '../../core/resources';
import { FleetQuantitativeUsage } from '../../model/stat/fleet-quantitative-usage';
import { FleetUsageLevel } from '../../model/stat/fleet-usage-level';
import { FleetUsage } from '../../model/stat/fleet-usage';

@Injectable()
export class StatsService {

  constructor(private api: Api) {
  }

  dailySales(): Observable<DailySales> {
    return this.api.get(RESOURCES.daily_sales);
  }

  fleetUsageLevel(): Observable<FleetUsageLevel> {
    return this.api.get(RESOURCES.fleet_usage_level);
  }

  fleetQuantitativeUsage(): Observable<FleetQuantitativeUsage> {
    return this.api.get(RESOURCES.fleet_quantitative_usage);
  }

  fleetUsage(): Observable<FleetUsage> {
    return this.api.get(RESOURCES.fleet_usage);
  }


}



// WEBPACK FOOTER //
// C:/projektyWeb/McComp_Flota/Front/src/app/resources/stats/stats.service.ts